<div class="img-footer">
  <div>
    <img src="./assets/images/vigilado-supersubsidio.png" alt="vigilado-supersubsidio">
  </div>
  <div>
    <img src="./assets/images/logo-droguerias.png" alt="logo-droguerias">
  </div>
</div>